<template>
  <div class="dashboard-page container">
    <div class="loader" v-if="loading">
      <div class="load-spinner"></div>
    </div>

    <div class="row">
      <card class="purple" :footer="false">
        <template slot="title">Welcome back</template>
        <template slot="body">
          <p>{{ user.full_name }}</p>
          <p>{{ user.email }}</p>
        </template>
        <template slot="footer">
          <button type="button" @click="$router.push('/profile')">
            Profile
          </button>
        </template>
      </card>

      <card class="green-title green-footer">
        <template slot="title">Your Course Combination</template>
        <template slot="body" v-if="studentHasCombination">
          <p>{{ studentCombination.code }}</p>
          <br />
          <p>{{ studentCombinationCourses.join(", ") }}</p>
        </template>
        <template slot="body" v-else>
          <p>Please upade your course combination</p>
        </template>
        <template slot="footer">
          <button type="button" @click="$router.push('/courses/combination')">
            Edit
          </button>
        </template>
      </card>

      <card class="orange-title orange-footer">
        <template slot="title">Your Active Subscription</template>
        <template slot="body" v-if="activeSubscriptions.length">
          <div
            v-for="(subscription, index) in activeSubscriptions"
            :key="index"
          >
            <p>
              <b>{{ subscription.name }}:</b>
              <br />
              <b style="margin-left: 5px;">from:</b>
              {{ subscription.pivot.start_at }}
              <br />
              <b style="margin-left: 5px;">to:</b>
              {{ subscription.pivot.end_at }}.
            </p>
          </div>
        </template>
        <template slot="body" v-else>
          <p>You don't have any active subscriptions</p>
        </template>
        <template slot="footer">
          <button type="button" disabled>
            View
          </button>
          <button
            type="button"
            @click="$router.push('/subscriptions/pq/subscribe')"
          >
            Subscribe
          </button>
        </template>
      </card>

      <card class="purple-title purple-footer">
        <template slot="title">Your School</template>
        <template slot="body">
          <p>Current: --</p>
          <p>Preparaing for: --</p>
        </template>
        <template slot="footer">
          <button type="button" @click="$router.push('profile')">
            Profile
          </button>
        </template>
      </card>

      <card class="purple-title purple-footer" style="cursor:wait;">
        <template slot="title">Take Courses</template>
        <template slot="body">
          <p>Coming soon...</p>
          <p>Prepare for upcoming exams with video courses and tests.</p>
          <p>You will be notified when lessons start.</p>
        </template>
        <template slot="footer">
          <button type="button" disabled>
            Coming soon...
          </button>
        </template>
      </card>

      <card class="orange-title orange-footer" style="cursor:wait">
        <template slot="title">Referral</template>
        <template slot="body">
          <p>Your link: <a href="#">referral-link</a></p>
          <p>Your referral balance is: #0</p>
        </template>
        <template slot="footer">
          <button type="button" disabled>
            Coming soon
          </button>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import card from "@/components/Card";

export default {
  name: "Dashboard",

  components: {
    card
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },

    studentHasCombination() {
      return this.$store.getters["student/hasCombination"];
    },

    studentCombination() {
      return this.$store.state.student.combination;
    },

    studentCombinationCourses() {
      return this.$store.getters["student/combinationCourses"].map(
        course => course.title
      );
    },

    activeSubscriptions() {
      return this.$store.getters["student/activeSubscriptions"].filter(
        sub => sub.type == "past-question"
      );
    }
  },

  mounted() {
    this.loading = true;
    this.$store
      .dispatch("auth/getUserDetails")
      .catch(() => {
        this.$store.commit("showAlert", {
          message: "Failed to load",
          status: "danger"
        });
      })
      .finally(() => {
        this.loading = false;
      });

    this.$store.dispatch("course/getCourses");
  }
};
</script>
